import { useI18n } from 'vue-i18n';
import {
  useSiteConfigStore,
  useStationConfigStore,
} from '@/views/app-modules/sites/src/routes/stores';
import { storeToRefs } from 'pinia';
import { TenderTypes } from '@centric-os/types';
import { computed } from 'vue';

export default () => {
  // Set localization
  const { t } = useI18n();

  //init station config store
  const stationConfigStore = useStationConfigStore();
  const { stationPublicConfig } = storeToRefs(stationConfigStore);
  let publicMealplanConfig = stationPublicConfig.value?.mealplan?.[0];
  if (!publicMealplanConfig) {
    const siteConfigStore = useSiteConfigStore();
    const { sitePublicConfig } = storeToRefs(siteConfigStore);
    publicMealplanConfig = sitePublicConfig.value?.mealplan?.[0];
  }

  // Computed for isBrandMx
  const brandMXOptions = computed<{ label: string; value: boolean }[]>(() => {
    const options = [
      { label: t('sites.singleSite.financialConfig.mealPlans.form.brandMXYes'), value: true },
      { label: t('sites.singleSite.financialConfig.mealPlans.form.brandMXNo'), value: false },
    ];

    return options;
  });

  const brandMEQOptions = computed<{ label: string; value: boolean }[]>(() => {
    const options = [
      { label: t('sites.singleSite.financialConfig.mealPlans.form.brandMEQYes'), value: true },
      { label: t('sites.singleSite.financialConfig.mealPlans.form.brandMEQNo'), value: false },
    ];

    return options;
  });

  const hasTenders = computed<boolean>(() => {
    return !!publicMealplanConfig?.tenders?.length;
  });

  const hasMXTenders = computed<boolean>(() => {
    if (hasTenders.value) {
      return publicMealplanConfig?.tenders?.some(
        (tender) => tender.type === TenderTypes.MEAL_EXCHANGE,
      );
    }
    return false;
  });

  const isBrandMX = computed<boolean>(() => {
    return !!publicMealplanConfig?.isBrandMX;
  });

  const hasMEQTenders = computed<boolean>(() => {
    if (hasTenders.value) {
      return publicMealplanConfig?.tenders?.some(
        (tender) => tender.type === TenderTypes.MEAL_EQUIVALENT,
      );
    }
    return false;
  });

  const isBrandMEQ = computed<boolean>(() => {
    return !!publicMealplanConfig?.isBrandMEQ;
  });

  return {
    brandMXOptions,
    hasMXTenders,
    isBrandMX,
    hasMEQTenders,
    brandMEQOptions,
    isBrandMEQ,
  };
};
